import { renderStoryblokComponents } from "../lib";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var Global = props => /*#__PURE__*/_jsxs(_Fragment, {
  children: [renderStoryblokComponents(props.header), renderStoryblokComponents(props.scripts), renderStoryblokComponents(props.footer)]
});
//# sourceMappingURL=global.js.map